import React, { useState, useRef, useEffect, useCallback } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Link } from 'react-router-dom';
import { WhatsApp } from '@mui/icons-material';
import MenuRoundedIcon from '@mui/icons-material/MenuRounded';
import jslogo from "../../assets/JS Logo Black Empty.png";
import '../../styles/NavBar.css';

const MobileNavbar = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isContactOpen, setIsContactOpen] = useState(false);
  const menuRef = useRef(null);

  // Confirm mobile view
  const isMobile = useMediaQuery({ maxWidth: 768 });

  const navLinks = [
    { title: 'Home', path: '/' },
    { title: 'Our Team', path: '/our_team' },
    { title: 'Work with Us', path: '/work_with_us' },
    { title: 'Blog & Insights', path: '/blog' },
    { title: 'Partner with Us', path: '/partnerwithus' }
  ];

  const contactOptions = [
    { icon: <WhatsApp />, text: '+65 8133 8483', link: 'https://wa.me/6581338483' },
    { icon: <WhatsApp />, text: '+65 8877 6944', link: 'https://wa.me/6588776944' }
  ];

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
    setIsContactOpen(false);
  };

  const toggleContactPopup = () => {
    setIsContactOpen(!isContactOpen);
  };

  const handleOutsideClick = useCallback((event) => {
    if (menuRef.current && !menuRef.current.contains(event.target)) {
      if (isContactOpen) {
        setIsContactOpen(false);
      } else {
        setIsMenuOpen(false);
      }
    }
  }, [isContactOpen]);

  useEffect(() => {
    // Only add event listener if menu is open
    if (isMenuOpen || isContactOpen) {
      document.addEventListener('mousedown', handleOutsideClick);
      return () => {
        document.removeEventListener('mousedown', handleOutsideClick);
      };
    }
  }, [isMenuOpen, isContactOpen, handleOutsideClick]);

  // If not mobile, return null to prevent rendering
  if (!isMobile) return null;

  return (
    <nav className="navbar">
      <div className="leftSide">
          <img src={jslogo} alt='jslogo' className="logo" />
      </div>
      <div className="rightSide">
        <button onClick={toggleMenu} className="menu-toggle">
          <MenuRoundedIcon />
        </button>
      </div>
        {isMenuOpen && (
          <div className="menu-overlay">
            <div ref={menuRef} className="menu-popup">
              {!isContactOpen ? (
                <>
                  <div className="nav-links">
                    {navLinks.map((link) => (
                      <Link
                        key={link.path}
                        to={link.path}
                        onClick={toggleMenu}
                        className="nav-link"
                      >
                        {link.title}
                      </Link>
                    ))}
                  </div>
                  <button 
                    onClick={toggleContactPopup} 
                    className="contact-button"
                  >
                    Contact Us!
                  </button>
                </>
              ) : (
                <div className="contact-popup">
                  <div className="contact-options">
                    {contactOptions.map((option, index) => (
                      <a 
                        key={index} 
                        href={option.link} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="contact-option"
                      >
                        <div className="contact-icon">{option.icon}</div>
                        <div className="contact-text">{option.text}</div>
                      </a>
                    ))}
                  </div>
                </div>
              )}
            </div>
          </div>
        )}

    </nav>
  );
};

export default MobileNavbar;